// Text for the vehicles & trailers section, kept apart from the main
// dictionary because it is large. Merged into the dictionary in I18nContext.
// Placeholders use {n}, {date}, {name}; see fillText() in utils/vehicleDisplay.js.

export const vehicleStrings = {
  ar: {
    navTitle: "المركبات والمقطورات",
    title: "المركبات والمقطورات",
    subtitle: "إدارة المركبات والمقطورات ورخصها وفحصها الدوري وتأمينها",
    add: "إضافة مركبة أو مقطورة",
    back: "العودة إلى القائمة",
    open: "فتح الملف",
    edit: "تعديل",
    archive: "أرشفة",
    restore: "استعادة من الأرشيف",
    save: "حفظ",
    saveChanges: "حفظ التعديلات",
    cancel: "إلغاء",
    retry: "إعادة المحاولة",
    loading: "جارٍ تحميل البيانات…",
    loadError: "تعذّر تحميل البيانات",
    empty: "لا توجد مركبات أو مقطورات مطابقة",
    emptyFirst: "لم تتم إضافة أي مركبة بعد",
    noPermission: "ليست لديك صلاحية لعرض هذا القسم",
    savedFirst: "احفظ المعلومات الأساسية أولًا لتفعيل بقية التبويبات",
    unsavedWarning: "لديك تغييرات لم تُحفظ",

    search: "بحث",
    searchPlaceholder: "رقم اللوحة أو الاسم الداخلي أو الشركة",
    filterType: "النوع",
    filterStatus: "الحالة",
    filterDocs: "المستندات",
    all: "الكل",
    docsExpiredOrSoon: "منتهية أو قريبة الانتهاء",
    docsExpired: "منتهية",
    docsSoon: "تنتهي قريبًا",
    docsUnknown: "معلومات ناقصة",

    summaryTotal: "الإجمالي",
    summaryActive: "نشطة",
    summaryExpired: "مستندات منتهية",
    summarySoon: "تنتهي قريبًا",
    summaryMissing: "معلومات ناقصة",

    type: { vehicle: "مركبة", trailer: "مقطورة" },
    status: { active: "نشطة", out_of_service: "خارج الخدمة", archived: "مؤرشفة" },

    col: {
      plate: "رقم اللوحة",
      type: "النوع",
      vehicle: "الشركة والموديل",
      responsible: "المسؤول",
      license: "انتهاء الرخصة",
      test: "الفحص الدوري القادم",
      insurance: "التأمين",
      status: "الحالة",
      actions: "إجراءات",
    },

    expiry: {
      expired: "منتهية منذ {n} يوم",
      expiredToday: "انتهت أمس",
      today: "تنتهي اليوم",
      inDays: "بعد {n} يوم",
      unknown: "غير معروف / معلومات ناقصة",
    },
    insuranceStatus: {
      active: "سارية وفق البيانات المسجّلة",
      future: "مستقبلية (لم تبدأ بعد)",
      expired: "منتهية",
      cancelled: "ملغاة",
      incomplete: "معلومات ناقصة",
      none: "لا يوجد تأمين مسجّل",
    },

    tabs: {
      basic: "المعلومات الأساسية",
      trailer: "بيانات المقطورة",
      license: "رخصة المركبة",
      test: "الفحص الدوري",
      insurance: "التأمين",
      documents: "المستندات",
      history: "سجل التغييرات",
    },

    f: {
      plate: "رقم اللوحة",
      nickname: "اسم داخلي (اختياري)",
      type: "النوع",
      classification: "تصنيف المركبة كما في الرخصة",
      make: "الشركة",
      model: "الموديل",
      year: "سنة الصنع",
      color: "اللون",
      chassisNumber: "رقم الهيكل (الشاصي)",
      registeredOwner: "المالك المسجّل",
      responsible: "المسؤول في الجمعية",
      noResponsible: "بدون مسؤول",
      status: "الحالة التشغيلية",
      notes: "ملاحظات",
      selfWeight: "الوزن الذاتي (كغم)",
      grossWeight: "الوزن الإجمالي المسموح (كغم)",
      payload: "الحمولة المسموحة (كغم)",
      brakes: "الفرامل",
      towingConditions: "شروط الجر وقيوده كما وردت في الرخصة",
      validFrom: "بداية الصلاحية",
      validUntil: "تاريخ انتهاء الرخصة",
      feeStatus: "حالة دفع رسوم الترخيص",
      feePaidDate: "تاريخ الدفع",
      feeAmount: "المبلغ",
      testDate: "تاريخ إجراء الفحص",
      testResult: "النتيجة",
      institute: "معهد الفحص",
      defects: "العيوب",
      retestDate: "موعد إعادة الفحص",
      nextTestDate: "الموعد الرسمي القادم للفحص",
      exemptionReason: "سبب الإعفاء",
      policyType: "نوع التأمين",
      insurer: "شركة التأمين",
      policyNumber: "رقم البوليصة",
      startDate: "بداية التغطية",
      endDate: "نهاية التغطية",
      cost: "التكلفة",
      deductible: "التحمل الذاتي",
      agentName: "اسم الوكيل",
      agentContact: "وسائل تواصل الوكيل",
      driverRestrictions: "قيود السائقين",
      minDriverAge: "الحد الأدنى لعمر السائق",
      towingAssistance: "خدمات الجر والمساعدة",
      reason: "سبب التغيير",
    },
    brakes: { yes: "نعم", no: "لا", unknown: "غير معروف" },
    feeStatus: { unknown: "غير معروف", unpaid: "غير مدفوع", paid: "مدفوع", exempt: "معفى" },
    testResult: { not_done: "لم يُجرَ", passed: "ناجح", failed: "غير ناجح", exempt: "معفى" },
    policyType: { mandatory: "إلزامي", third_party: "طرف ثالث", comprehensive: "شامل", other: "آخر" },
    docKind: { license: "رخصة", policy: "بوليصة", test: "نتيجة فحص", receipt: "إيصال", other: "آخر" },

    licenseNote: "دفع الرسوم وحده لا يعني أن الرخصة سارية أو أن الفحص اجتيز.",
    testNote: "الموعد القادم يُدخل كما ورد في المستند الرسمي، ولا يُحسب تلقائيًا.",
    trailerNote: "لا يُستنتج جواز الجر من هذه الحقول، ولا يُفترض أن المقطورة مرتبطة بسيارة واحدة.",
    insuranceNote: "التغطية المؤكدة للمقطورة تُسجَّل بمستنداتها، ولا يُفترض أنها مشمولة بتأمين السيارة.",
    correctionNeedsReason: "تغيير التاريخ يتطلب كتابة سبب التصحيح",

    addLicense: "تجديد رخصة أو إضافتها",
    addTest: "تسجيل فحص",
    addPolicy: "إضافة بوليصة",
    setNextTest: "تصحيح الموعد الرسمي القادم",
    voidRecord: "إلغاء السجل",
    cancelPolicy: "إلغاء البوليصة",
    cancelledOn: "أُلغيت بتاريخ {date}",
    voidedOn: "أُلغي بتاريخ {date}",
    history: "السجل السابق",
    noRecords: "لا توجد سجلات بعد",
    current: "الحالي",
    correctionLog: "تصحيح: {from} ← {to} ({reason})",
    askReason: "اكتب السبب:",

    fileName: "اسم الملف (اختياري)",
    fileNameHint: "مثال: إيصال تجديد الرخصة 2026",
    rename: "تغيير الاسم",
    removeFile: "حذف الملف",
    removeConfirm: "حذف «{name}» نهائيًا من النظام ومن Google Drive؟",
    renamed: "تم تغيير الاسم",
    fileRemoved: "تم حذف الملف",
    attachments: "المرفقات",
    attach: "إرفاق ملف",
    uploading: "جارٍ الرفع…",
    uploadDocument: "رفع مستند",
    chooseFile: "اختر ملفًا (PDF أو صورة، حتى 10MB)",
    linkedTo: "مرتبط بـ",
    linkVehicle: "المركبة عمومًا",
    replaces: "يستبدل مستندًا سابقًا",
    noReplace: "مستند جديد",
    superseded: "نسخة قديمة",
    download: "تنزيل",
    view: "عرض",
    noDocuments: "لا توجد مستندات",
    documentsNoAccess: "ليست لديك صلاحية الوصول إلى المستندات",
    uploaded: "تم رفع المستند",

    auditEmpty: "لا توجد تغييرات مسجّلة",
    auditBy: "بواسطة {name}",
    actions: {
      create: "إنشاء",
      update: "تعديل البيانات",
      archive: "أرشفة",
      restore: "استعادة",
      "license.add": "إضافة رخصة",
      "license.update": "تصحيح رخصة",
      "license.retire": "إلغاء سجل رخصة",
      "test.add": "تسجيل فحص",
      "test.update": "تصحيح فحص",
      "test.retire": "إلغاء سجل فحص",
      "policy.add": "إضافة بوليصة",
      "policy.update": "تصحيح بوليصة",
      "policy.retire": "إلغاء بوليصة",
      "nextTest.set": "تغيير موعد الفحص القادم",
      "document.add": "رفع مستند",
      "document.rename": "تغيير اسم مستند",
      "document.delete": "حذف مستند",
    },

    lookup: {
      needPlate: "اكتب رقم اللوحة أولًا (من 5 إلى 8 أرقام فقط) لتفعيل الجلب.",
      button: "جلب من بيانات وزارة المواصلات",
      loading: "جارٍ البحث…",
      title: "اقتراح من data.gov.il — راجعه قبل التطبيق",
      source: "المصدر: data.gov.il · جُلب بتاريخ {date}",
      current: "المسجّل حاليًا",
      official: "في المصدر الرسمي",
      conflict: "يختلف عن القيمة المسجّلة، ولن يُستبدل إلا إذا حدّدته",
      apply: "تطبيق المحدد",
      close: "إغلاق",
      noChanges: "البيانات الوصفية مطابقة لما هو مسجّل أو غير متوفرة في المصدر",
      infoTitle: "معلومات من المصدر (لا تُطبَّق تلقائيًا)",
      infoNote: "ليس لتواريخ المصدر تعريف منشور، لذلك لا تُحوَّل إلى تاريخ الرخصة أو الفحص الدوري. أدخل هذه التواريخ من المستندات الرسمية.",
      applied: "طُبِّقت الحقول المحددة ({n}). راجعها ثم احفظ.",
      manualHint: "الإدخال اليدوي متاح دائمًا حتى لو تعذّر الجلب.",
    },

    del: {
      button: "حذف نهائي",
      title: "حذف المركبة نهائيًا",
      warning: "سيُحذف كل ما يخص هذه المركبة: بياناتها والرخص والفحوصات والبوالص والمستندات (من Google Drive أيضًا) وسجل التغييرات. لا يمكن التراجع. إن أردت الاحتفاظ بها فاستخدم الأرشفة.",
      confirmLabel: "اكتب رقم اللوحة {plate} للتأكيد",
      confirm: "حذف كل شيء نهائيًا",
      done: "تم حذف المركبة وكل سجلاتها",
    },

    alertsTitle: "تنبيهات المركبات",
    alertsNone: "لا توجد تنبيهات للمركبات",
    alertsMore: "وتنبيهات أخرى: {n}",
    alertsOpen: "فتح المركبات",
    alertKind: { license: "الرخصة", test: "الفحص الدوري", insurance: "التأمين" },
    alertLevel: {
      expired: "منتهية",
      due0: "تنتهي اليوم",
      due7: "خلال 7 أيام",
      due14: "خلال 14 يومًا",
      due30: "خلال 30 يومًا",
      due60: "خلال 60 يومًا",
      missing: "معلومات ناقصة",
    },

    scan: {
      button: "📄 قراءة مستند",
      hint: "صورة أو PDF للرخصة أو بوليصة التأمين",
      reading: "جارٍ قراءة المستند…",
      title: "بيانات مقترحة من المستند",
      apply: "تعبئة النموذج",
      dismiss: "تجاهل",
      applied: "تمت تعبئة الحقول ({n}). راجعها قبل الحفظ",
      skipped: "حقول لم تُستبدل لأنها معبّأة مسبقًا: {n}",
      attach: "إرفاق الملف بالسجل بعد الحفظ",
      unavailable: "قراءة المستندات غير مفعّلة على الخادم",
      otherType: "يبدو أن هذا المستند من نوع آخر",
      warnings: {
        plate_mismatch: "رقم اللوحة في المستند لا يطابق هذه المركبة",
        dates: "بعض التواريخ غير واضحة أو غير منطقية وتُركت فارغة",
        invalid_plate: "رقم اللوحة في المستند غير واضح",
      },
    },

    archiveConfirm: "هل تريد أرشفة هذه المركبة؟ تبقى بياناتها ومستنداتها محفوظة ويمكن استعادتها.",
    archiveReason: "سبب الأرشفة (اختياري)",
    created: "تمت إضافة المركبة بنجاح",
    updated: "تم حفظ التعديلات بنجاح",
    recordSaved: "تم حفظ السجل",
    archived: "تمت أرشفة المركبة",
    restored: "تمت استعادة المركبة",
  },
};
